import withAdPartner from './withAdPartner';
import withEditAdPartner from './withEditAdPartner';
import { EditAdPartner as View } from './View';

const EditAdPartner = withAdPartner(withEditAdPartner(View));

export default EditAdPartner;
